import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

import { fontStyle } from '../../theme/helpers/fontStyle';

export const $KeyShortcut = styled.div<{ $height: number }>`
  display: flex;
  align-items: center;
  justify-content: center;

  text-transform: uppercase;
  font-weight: ${fontWeight('bold')};
  ${fontStyle('xs')};
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  background-color: ${({ theme }) => theme.systemColors.secondaryBackground};
  color: ${({ theme }) => theme.colors.mainTextColor};

  margin-right: ${spacing('xxs')};
  &:not(:first-child) {
    margin-left: ${spacing('xxs')};
  }
  height: ${({ $height }) => rem($height)};
  min-width: ${({ $height }) => rem($height)};
  line-height: ${({ $height }) => rem($height)};
  span:not(:last-child) {
    padding-right: ${spacing('xs')};
  }
  span:not(:first-child) {
    padding-left: ${spacing('xs')};
  }
  padding-right: ${spacing('xs')};
  padding-left: ${spacing('xs')};
  svg {
    max-width: ${spacing(5)};
    color: ${({ theme }) => theme.colors.mainTextColor};
  }
`;
